/* eslint-disable no-param-reassign */
import { AGREEMENT_TYPE, INTAKER_TYPE } from '@/utils/constants';

export default {
  namespaced: true,
  state: () => ({
    agreements: [
      {
        type: AGREEMENT_TYPE.REFUND,
        accepted: false,
        required: true,
      },
      {
        type: AGREEMENT_TYPE.PRIVACY,
        accepted: false,
        required: true,
      },
      {
        type: AGREEMENT_TYPE.SENSITIVE,
        accepted: false,
        required: true,
      },
      {
        type: AGREEMENT_TYPE.CONSULTATION,
        accepted: false,
        required: true,
      },
      {
        type: AGREEMENT_TYPE.PROXY_CONSENT,
        accepted: false,
        required: true,
      },
    ],
    targetIntaker: null,
    targetRange: null,
    targetSex: null,
  }),
  mutations: {
    init(state) {
      state.agreements.forEach((n) => {
        n.accepted = false;
      });
      state.targetIntaker = null;
      state.targetRange = null;
      state.targetSex = null;
    },
    updateAgreementType(state, payload) {
      state.agreements.find((n) => n.type === payload.type).accepted = payload.accepted;
    },
    updateTargetIntaker(state, payload) {
      state.targetIntaker = payload.targetIntaker;

      const setAgreementRequired = (type, required) => {
        const agreement = state.agreements.find(agreement => agreement.type === type);
        if (agreement) agreement.required = required;
      };

      if (state.targetIntaker === INTAKER_TYPE.SELF) {
        setAgreementRequired(AGREEMENT_TYPE.PROXY_CONSENT, false);
        setAgreementRequired(AGREEMENT_TYPE.SENSITIVE, true);
      } else if (state.targetIntaker === INTAKER_TYPE.OTHER) {
        setAgreementRequired(AGREEMENT_TYPE.PROXY_CONSENT, true);
        setAgreementRequired(AGREEMENT_TYPE.SENSITIVE, false);
      }
    },
    updateTargetRange(state, payload) {
      state.targetRange = payload.targetRange;
    },
    updateTargetSex(state, payload) {
      state.targetSex = payload.targetSex;
    },
  },
  actions: {
    init({ commit }) {
      commit('init');
    },
    updateAgreementType({ commit }, payload) {
      commit('updateAgreementType', payload);
    },
    updateTargetIntaker({ commit }, payload) {
      commit('updateTargetIntaker', payload);
    },
    updateTargetRange({ commit }, payload) {
      commit('updateTargetRange', payload);
    },
    updateTargetSex({ commit }, payload) {
      commit('updateTargetSex', payload);
    },
  },
  getters: {
    agreed: (state) =>
      state.agreements.every(n => !n.required || n.accepted),
    targetIntaker: (state) => state.targetIntaker,
    targetRange: (state) => state.targetRange,
    targetSex: (state) => state.targetSex,
    canProceed: (state, getters) =>
      !!(getters.agreed && state.targetIntaker && state.targetRange && state.targetSex),
  },
};
